import { asyncAction } from 'lib/actions';

export const fetchOccupationAction = asyncAction('occupation/FETCH');
